import { CloseIcon } from "@chakra-ui/icons";
import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { useRemoveMultipleSpotsMutation } from "./index.generated";
import { WriteLeftDotLine } from "../ComponentLayouter/WriteLeftDotLine";

export const DeleteOptionalSpots = ({
  courseId,
  parentSpotId,
}: {
  courseId: string;
  parentSpotId: string;
}) => {
  const [, removeMultipleSpots] = useRemoveMultipleSpotsMutation();

  return (
    <WriteLeftDotLine>
      <Box
        data-testid={"delete-additional-spots"}
        my={2}
        p={3}
        flex={1}
        color="white"
        bgColor="#071223"
        justifyContent={"space-between"}
      >
        <Flex alignItems="center" justifyContent={"space-between"} w="full">
          <Text>このオプションの経由地群を削除</Text>
          <IconButton
            aria-label="remove"
            icon={<CloseIcon fontSize="xs" />}
            colorScheme="white"
            rounded="full"
            size="xs"
            onClick={() => {
              removeMultipleSpots(
                {
                  input: { courseId, parentSpotId },
                },
                { additionalTypenames: ["Course", "RoutingInfomationPayload"] }
              );
            }}
          />
        </Flex>
      </Box>
    </WriteLeftDotLine>
  );
};
